import type { AnimalWhereInput, DogInfoWhereInput, StudInfoWhereInput } from '@gql/graphql';
import type { StudListPageFormValues } from '@presentation/pages';
import { intersection } from 'lodash/fp';
import { useCallback } from 'react';

export const useStudWhereBuilder = () => {
  const studWhereBuilder = useCallback((form?: StudListPageFormValues): AnimalWhereInput => {
    const whereInputs: AnimalWhereInput[] = [
      { owner: { is: { dogBreeder: { is: { certified: { equals: true } } } } } },
    ];
    const dogInfos: DogInfoWhereInput = {};
    const studInfos: StudInfoWhereInput = { availableForBreeding: { equals: true } };

    if (form) {
      if (form.countries?.length && whereInputs[0].owner?.is?.dogBreeder?.is) {
        whereInputs[0].owner.is.dogBreeder.is.account = {
          is: {
            address: {
              is: {
                country: { in: form.countries },
              },
            },
          },
        };
      }
      if (form.regions?.length && whereInputs[0].owner?.is?.dogBreeder?.is) {
        whereInputs[0].owner.is.dogBreeder.is.account = {
          is: {
            address: {
              is: {
                region: { in: form.regions },
              },
            },
          },
        };
      }

      if (form.breedNames?.length) {
        dogInfos.dogBreed = {
          is: {
            OR: [{ name: { in: form.breedNames } }, { baseBreedName: { in: form.breedNames } }],
          },
        };
      }

      if (form.pedigree?.length) {
        const hasFci = !!intersection(form.pedigree, ['id1', 'FCI', 'fci']).length;
        const hasOther = form.pedigree.includes('OTHER');
        if (hasFci && hasOther) {
          dogInfos.pedigree = { not: { equals: null } };
        } else if (hasFci) {
          dogInfos.pedigree = { in: ['FCI', 'fci', 'id1'] };
        } else if (hasOther) {
          dogInfos.pedigree = { not: { in: ['', 'FCI', 'fci', 'id1'] } };
        }
      }

      if (typeof form.champion === 'boolean') {
        studInfos.champion = { equals: form.champion };
      }

      whereInputs.push({ dogInfos: { is: dogInfos } });
      whereInputs.push({ studInfos: { is: studInfos } });
    }

    return { AND: whereInputs };
  }, []);

  return { studWhereBuilder };
};
